import type { Params } from "../toQueryString";
import { buildPath } from "./buildPath";

export const circleAiConversations = {
  list: ({ params = {} }: { params?: Params } = {}) =>
    buildPath("/internal_api/circle_ai/conversations", params),
  archive: ({ id }: { id: string }) =>
    buildPath(`/internal_api/circle_ai/conversations/${id}/archive`),
  update: ({ id }: { id: string }) =>
    buildPath(`/internal_api/circle_ai/conversations/${id}`),
  destroy: ({ id }: { id: string }) =>
    buildPath(`/internal_api/circle_ai/conversations/${id}`),
  submitFeedback: ({ id }: { id: string }) =>
    buildPath(`/internal_api/circle_ai/conversations/${id}/feedback`),
  toolCall: ({ id, toolCallId }: { id: string; toolCallId: string }) =>
    buildPath(
      `/internal_api/circle_ai/conversations/${id}/tool_calls/${toolCallId}`,
    ),
};
